function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.9859571mm",
    height: "21.493502mm",
    viewBox: "0 0 8.9859571 21.493502",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.635574,-114.44136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.560314,37.259349)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 7.568239,98.182531 v -20 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 3.568239,77.682008 h 8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 5.249098,84.348975 9.88738,88.554392 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 5.2490979,88.191179 4.6382822,4.205417 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreble1);
export default __webpack_public_path__ + "static/media/treble-1.6e4628735e83601153af7aaf49a9153f.svg";
export { ForwardRef as ReactComponent };